import pluralize from 'pluralize'
import {TextInput} from '@primer/react'
import type {ConvertToRulesetPreview} from '../types'
import {useUpdatePreviews} from '../contexts/UpdatePreviewsContext'

export type PreviewProps = {
  preview: ConvertToRulesetPreview
}

export function Preview({preview}: PreviewProps) {
  const {setRulesetName} = useUpdatePreviews()
  const rulesetCount = preview.rulesets.length
  return (
    <div className="d-flex flex-column gap-1">
      <span className="color-fg-muted">
        {rulesetCount} {pluralize('ruleset', rulesetCount)}
      </span>
      {preview.rulesets.map((ruleset, index) => (
        <TextInput
          value={ruleset.name}
          key={ruleset.title}
          onChange={ev => {
            setRulesetName({
              id: preview.id,
              rulesetIndex: index,
              newRulesetName: ev.target.value,
            })
          }}
        />
      ))}
    </div>
  )
}
